<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">角色管理</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
            <div style="display:inline-block;" v-if="isbutShow.selectBut">
             <template>
                <Input v-model="key" placeholder="角色名称" style="width: 300px"></Input>
            </template>
              
              <Button type="ghost" class="mRight mLeft" @click="showKeyList()" v-if="isbutShow.selectBut">查询</Button>
              
            </div>
          
            <Button type="primary" class="mRight" v-if="isbutShow.addBut" @click="addAdmin">新增</Button> 

            <Button @click="upDateAdmin" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
            <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delAdmins">删除</Button>
             
          </div>

          <div class="clearfix"></div>
          <div class="table-wrapper">
            <Table style="min-width: 700px" border :columns="columns" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
             <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div> 
         

        </div>
      </div>


    </div>
   
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
  // .ivu-modal-footer{
  //   text-align:center !important;
  // }
  // .ivu-form-item-content{
  //   text-align:left;
  // }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  // import treeCom from '../../components/tree'
  // import TreeGrid from '../../components/TreeGridRole'
  
  export default{
    data(){
      return {
       // dataTable: [],
       isbutShow:{
        addBut: false,
        delBut: false,
        updateBut: false,
        selectBut: false,
       },
       permissionsLists:[],
        activeName:'',
        key:'',
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        columns: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: '角色ID',
                // type: 'index',
                key:'roleId',
                width: 100,
                align: 'center'
            },
            {
                title: '角色名称',
                key: 'roleName',
                align: 'center'
            },
            {
                title: '所属部门',
                key: 'deptList',
                align: 'center',
                 render:(h, params) => {
                  const row = params.row;
                  const object = row.deptList;
                  // console.log(object)
                  var Name = "";
                  object.forEach(r=>{ 
                      // console.log(r.name) 
                      Name+= r.name+"," 
                  })  

                  return h('span',Name );
                }
            },
            {
                title: '备注',
                key: 'remark',
                align: 'center'
            },
            {
                title: '创建时间',
                key: 'createTime',
                align: 'center',
            },
           
        ],
        addModel: false,
        updateModel:false,
        modalDept:false,
        resourcesDept:[],
        treeNodeId:'',
        selnodeType: '',
        nodeNumber: 1,
        editNodeModel: false,
        selNodetoEdit: {},
        selectionRows:{},
        updateId:'',
        
        modal_loading: false,
      
      }
    },
    mounted:function(){ 
     // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        console.log(r.name)
        if(r.name == "查看"){
          this.isbutShow.selectBut = true;
        }else if(r.name == "新增"){
          this.isbutShow.addBut = true;
        }else if(r.name == "修改"){
          this.isbutShow.updateBut = true;
        }else if(r.name == "删除"){
           this.isbutShow.delBut = true;
        }

      })
       // ----------- 权限显示end -------------

        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
    },
    methods: {
        // selectionClick(arr) {
        //     // var object = this.deptLists;
           
        //     // this.selectionRows =[];
        //     console.log(arr)

        //     // object.forEach(r=>{ 
        //     //   if(arr.indexOf(r.deptId) !== -1){
        //     //    // console.log(r)
        //     //    this.selectionRows.push(r)
        //     //   }
             
        //     // })
        //     // console.log(this.selectionRows)
        // },
        getLists(pageCurrent,pagesize){
            // var token = sessionStorage.getItem("token");
            api.Role.getLists({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
              console.log(resp)
               // 获取分页展示list
               this.pagerData.data = resp.page.list;
               console.log(this.pagerData.data)
               // 获取分页总条数
               this.pagerData.page.totalCount = resp.page.totalCount;
              // this.getallgateway();
            }, error => {

            })
        // 是否具有增删改查按钮权限
        // var menuLeftList = JSON.parse(localStorage.getItem('menuLeftList'));
        // console.log(menuLeftList[0].list)

        

        // // var list = {
        // //   add:false,
        // //   del:true,
        // //   updata:true,
        // //   select:true
        // // }
        // this.isbutShow.addBut = true;
        // this.isbutShow.delBut = true;
        // this.isbutShow.updateBut = true;
        // this.isbutShow.selectBut = true;
        },
        // 搜索关键词
        showKeyList(){
            // if(this.key == ''){
            //      this.$Message.error('查询关键词不能为空!');
            // }else{
              // console.log('通过关键词获取列表')
               api.Role.getLists({
                    'page':this.pagerData.page.pageCurrent,
                    'limit':this.pagerData.page.pagesize,
                    'role_name':this.key,
                }, resp => {
                  // console.log(resp)
                  // 获取分页展示list
                  this.pagerData.data = resp.page.list;
                  // console.log(this.pagerData.data)
                  // 获取分页总条数
                   this.pagerData.page.totalCount = resp.page.totalCount;
                   //this.key = '';
                }, error => {
                  
                })

            //}
        },
        
        // 删除/批量删除
        delAdmins(){
            console.log(this.selectionRows)
            var roleIds = [];
            for(var i=0 ;i < this.selectionRows.length; i++){
                console.log(i);
                roleIds.push(this.selectionRows[i].roleId);
            }
            console.log(roleIds)
            // 执行删除
            this.delAdmin(roleIds);
        },
        // 新增 初始化数据
        addAdmin:function(){
            this.activeName = '新增';
             this.$router.push({ 
              name: 'roleAdd',
              params:{
                activeName:this.activeName
              } 
            })
        },

        // 修改
        upDateAdmin:function(index){
          this.activeName = '修改';
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.selectionRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }
          var roleId = []
          // console.log(this.selectionRows[0])
          roleId.push(this.selectionRows[0].roleId);
          // console.log(roleId)
          this.$router.push({ 
            name: 'roleAdd',
            params:{
                roleId:roleId,
                currList:this.selectionRows[0],
                activeName:this.activeName
            } 
          })
        },
        getSelection:function(selection){
          // console.log(222)
            console.log(selection)
            this.selectionRows = selection;
            // return selection;
        },
        // 分页 -- 页数改变
        onChange:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.pagerData.page.pageCurrent = curpage;
            this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pagerData.page.pagesize = size;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        } ,
        delAdmin:function(roleIds){
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请至少选择一条记录!');
              return;
          }
          var roleIds = [];
          for(var i=0 ;i < this.selectionRows.length; i++){
              console.log(i);
              roleIds.push(this.selectionRows[i].roleId);
          }
          console.log(roleIds)
          api.Role.delRole(roleIds
          , resp => {
            console.log(resp)
            if(resp.code == 0){
              this.$Message.success('删除成功!');
              this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
            }else {
                  this.$Message.error('删除失败：'+ resp.msg);
           }
            

          }, error => {

          })
        }

    },

      components: {}
    }
</script>



// WEBPACK FOOTER //
// role.vue?165240d6